import React from 'react';
import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
// import { Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  AddCarTowingListing,
  UpdateCarTowingListing,
  getCarTowingAllListing,
  AddMedia,
  getCarBrand,
} from './../../../../Redux/Actions/UserAction';
import Swal from 'sweetalert2';
import { sanitizeWhatsAppFields } from '../../../../utils/sanitizeWhatsApp';
import { CommonBusinessHeader } from '../CommonBusinessHeader';
import { useTranslation } from 'react-i18next';
import useBusinessGuard from '../../../../hooks/useBusinessGuard';
import Sidebar from '../../../common/Sidebar/Sidebar';
import MapModal from '../../../common/Modal/MapModel';

// const API = 'https://api.carsavenue.com/api';
const API = 'https://api.carsavenue.com/api';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const CarTawing = () => {
  // [CF 2026-08-17 #11] This screen never had translation wired in.
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17] The brand dropdown listed TOYOTA / CHEVROLET / NISSAN in
     English on the Arabic site. Every brand in the master carries `nameAr`, so
     show the one that matches the language. */
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const brandLabel = (brand) =>
    (isRTL ? brand?.nameAr || brand?.name : brand?.name || brand?.nameAr) || '';

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const home = useSelector((state) => state?.home);
  const CarBrand = home?.garageCarBrandList;
  const TowingAllList = home?.getTowingAllList;
  const getMybusiness = home?.getMybusiness;

  // Authoritative "do I already own this (towing) business?". getMybusiness is
  // set once /business/my resolves and is NOT clobbered by the listing fetch
  // (which can momentarily return empty). Deciding add-vs-update off
  // TowingAllList alone caused a POST (→ "already registered") on an existing
  // business. Treat the business as existing if EITHER source says so.
  const ownsTowingBusiness =
    getMybusiness?.businessCode === 'CAR10' && !!getMybusiness?.businessId;
  const businessExists =
    (TowingAllList?.length || 0) > 0 || ownsTowingBusiness;

  const [LogoImage, setLogoImage] = useState();
  const [CarImage, setCarImage] = useState();
  const [LicenseImage, setLicenseImage] = useState();
  // true = hidden from users (backend `invisible` boolean); false = visible.
  const [invisible, setInvisible] = useState(false);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [CarTowing, setCarTowing] = useState({
    car: '',
    towingCompanyName: '',
    gps: { lat: '', long: '' },
    location: '',
    plateNumber: '',
    mobileNumberCountryCode: '',
    mobileNumber: '',
    mobileNumbers: [
      {
        countryCode: '',
        mobileNumber: '',
      },
    ],
    whatsAppNumber: '',
    whatsAppNumberCountryCode: '',
    invisible: false,
    mediaIds: {
      LOGO: [''],
      LICENSE: [''],
      IMAGES: [''],
    },
  });

  const dispatch = useDispatch();

  // One business per account: redirect if the user already owns a different
  // business instead of letting this add-form fail on save.
  useBusinessGuard('CAR10');

  function handleChange(e) {
    const { name, value } = e.target;
    setCarTowing((user) => ({ ...user, [name]: value }));
  }

  useEffect(() => {
    // Guard on length, not truthiness — an empty array [] is truthy and would
    // prefill every field with undefined, blanking the form.
    if (TowingAllList?.length) {
      setInvisible(!!TowingAllList[0]?.invisible);
      let gps;
      try {
        gps =
          typeof TowingAllList[0]?.gps === 'string'
            ? JSON.parse(TowingAllList[0]?.gps)
            : TowingAllList[0]?.gps;
      } catch (e) {
        gps = undefined;
      }
      setCarTowing({
        towingCompanyName: TowingAllList[0]?.towingCompanyName,
        plateNumber: TowingAllList[0]?.plateNumber,
        mobileNumberCountryCode: TowingAllList[0]?.mobileNumberCountryCode,
        mobileNumber: TowingAllList[0]?.mobileNumber,
        whatsAppNumber: TowingAllList[0]?.whatsAppNumber,
        whatsAppNumberCountryCode: TowingAllList[0]?.whatsAppNumberCountryCode,
        car: TowingAllList[0]?.car,
        location: TowingAllList[0]?.location || '',
        gps: { lat: gps?.lat || '', long: gps?.long || '' },
      });
      setLogoImage(
        TowingAllList
          ? TowingAllList[0]?.businessMedia.filter(
              (data) => data.mediaType == 'LOGO'
            )[0]?.media?.path
          : ''
      );
      setLicenseImage(
        TowingAllList
          ? TowingAllList[0]?.businessMedia.filter(
              (data) => data.mediaType == 'LICENSE'
            )[0]?.media?.path
          : ''
      );
      setCarImage(
        TowingAllList
          ? TowingAllList[0]?.businessMedia.filter(
              (data) => data.mediaType == 'IMAGES'
            )[0]?.media?.path
          : ''
      );
    }
  }, [TowingAllList]);

  useEffect(() => {
    dispatch(getCarBrand());
    var data = {
      towingOwnerId: sessionStorage.getItem('BusinessId'),
    };
    dispatch(getCarTowingAllListing(data));
  }, []);

  const handleUploadImage = (event) => {
    // alert('fdf')
    const id = event.target.id;
    const file = event.target.files[0];

    const reader = new FileReader();
    console.log('this is the reader section ', id);
    reader.readAsDataURL(file);

    const formData = new FormData();

    formData.append('media', file);

    axios
      .post(API + '/media/new', formData, config)

      .then((res) => {
        console.log('this is response', res.data.response.media[0].mediaId);
        Swal.fire({
          title: 'Upload Successfully',
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });

        const LogoId = res?.data?.response?.media[0]?.mediaId;
        if (id === 'Image') {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            setLogoImage(reader.result);
          };

          console.log('logoid', LogoId);

          setCarTowing({
            ...CarTowing,
            mediaIds: {
              ...CarTowing.mediaIds,
              LOGO: [LogoId],
            },
          });
        } else if (id === 'CarImage') {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            setCarImage(reader.result);
          };

          setCarTowing({
            ...CarTowing,
            mediaIds: {
              ...CarTowing.mediaIds,
              IMAGES: [LogoId],
            },
          });
        } else if (id === 'License') {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            setLicenseImage(reader.result);
          };

          setCarTowing({
            ...CarTowing,
            mediaIds: {
              ...CarTowing.mediaIds,
              LICENSE: [LogoId],
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title:
            err?.response !== undefined
              ? err?.response?.data?.response?.message
              : 'something went wrong Upload again!!!',
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });
      });
  };

  useEffect(() => {
    setCarTowing((prev) => ({
      ...prev,
      mobileNumbers: [
        {
          countryCode: CarTowing.mobileNumberCountryCode,
          mobileNumber: CarTowing.mobileNumber,
        },
        {
          countryCode: CarTowing.whatsAppNumberCountryCode,
          mobileNumber: CarTowing.whatsAppNumber,
        },
      ],
    }));
  }, [
    CarTowing.mobileNumberCountryCode,
    CarTowing.mobileNumber,
    CarTowing.whatsAppNumberCountryCode,
    CarTowing.whatsAppNumber,
  ]);

  // Block a second Save click from firing a duplicate create while in flight.
  const submittingRef = useRef(false);

  const datasubmit = () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setTimeout(() => {
      submittingRef.current = false;
    }, 4000);
    const _payload = sanitizeWhatsAppFields(CarTowing);
    if (businessExists) {
      dispatch(UpdateCarTowingListing(_payload));
    } else {
      dispatch(AddCarTowingListing(_payload));
    }
  };

  // Validate the form before submit. Returns an error message, or null if OK.
  const validateTowing = () => {
    if (!CarTowing.towingCompanyName || !String(CarTowing.towingCompanyName).trim())
      return 'Please enter the business name.';
    if (!CarTowing.car) return 'Please select a car brand.';
    if (!CarTowing.plateNumber || !String(CarTowing.plateNumber).trim())
      return 'Please enter the plate number.';
    if (!/^\d{8}$/.test(String(CarTowing.mobileNumber || '')))
      return 'Phone number must be 8 digits.';
    if (
      CarTowing.whatsAppNumber &&
      !/^\d{8}$/.test(String(CarTowing.whatsAppNumber))
    )
      return 'WhatsApp number must be 8 digits.';
    if (!CarTowing.location || !String(CarTowing.location).trim())
      return 'Please select your location on the map.';
    return null;
  };

  const onSubmitGuarded = () => {
    const err = validateTowing();
    if (err) {
      Swal.fire({ title: err, icon: 'warning' });
      return;
    }
    datasubmit();
  };

  const ResetHendler = () => {
    setCarTowing({});
  };

  const handleOpenMap = () => setMapModalOpen(true);
  const handleCloseMap = () => setMapModalOpen(false);
  const handleLocationSelect = (loc) => {
    setCarTowing((prev) => ({
      ...prev,
      location: loc.address,
      gps: { lat: loc.lat, long: loc.long },
    }));
  };

  // Flip visibility in one click via the sidebar toggle — no modal. Update the
  // UI immediately and persist the new boolean to the backend.
  const onToggleVisibility = () => {
    const next = !invisible;
    setInvisible(next);
    dispatch(UpdateCarTowingListing({ invisible: next }));
  };

  /* [CF 2026-08-17 G4] Towing is a "lite" category — it has no banner,
     services or working-hours pages — so its section list is the profile plus
     the plan. `noGate` keeps Manage Packages open, since that is where the plan
     is bought and locking it behind owning one would be a dead end. */
  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-car-towing',
      label: t('Manage Profile'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/manage-package',
      label: t('Manage Packages'),
      noGate: true,
    },
  ];

  const visibilityRow = businessExists ? (
    <div className="cav-visibility-row">
      <img src="assets/images/icons/sp-business/visible.svg" alt="" />
      <span>{invisible ? t('Hidden') : t('Visible')}</span>
      <label className="cav-switch" title={t('Show / hide my listing')}>
        <input
          type="checkbox"
          checked={!invisible}
          onChange={onToggleVisibility}
        />
        <span className="cav-switch-slider"></span>
      </label>
    </div>
  ) : null;

  return (
    <div>
      <CommonBusinessHeader dataList={TowingAllList} getNameKey="carRentName" />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            {/* [CF 2026-08-17 G4] Hand-built column replaced by the shared
                Sidebar. Towing and Taxi were the only two categories not using
                it, which is exactly why they alone skipped the mobile hub and
                opened straight onto the form. The plan card, the section rows
                and the visibility switch are all preserved - they just come
                from the component now, so every category behaves the same. */}
            <Sidebar options={sideBarOpt} extra={visibilityRow} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2>Manage Profile</h2>

              <form onSubmit={handleSubmit(onSubmitGuarded)}>
                <div class="form-group">
                  <label for="g-mb-business-name">Name</label>
                  <input
                    name="towingCompanyName"
                    type="text"
                    value={CarTowing.towingCompanyName}
                    onChange={handleChange}
                    className="form-control"
                    id="g-mb-business-name"
                    placeholder="Business Name"
                  />
                </div>

                <div class="form-group">
                  <label for="Brand">Select Car Brand</label>
                  <select
                    class="form-control"
                    id="Brand"
                    name="car"
                    value={CarTowing.car}
                    onChange={handleChange}
                  >
                    <option>{t('- Select Car Brand -')}</option>
                    {CarBrand !== undefined && CarBrand.length
                      ? CarBrand.map((brand, idx) => (
                          <option value={brand.brandId}>{brandLabel(brand)}</option>
                        ))
                      : null}
                  </select>
                </div>

                {/* <div class='form-group'>
									<label for='Model'>Select Car Model</label>
									<select class='form-control'
										id='Model'
										name='CarModel'
										value={CarTowing.CarModel}
										onChange={handleChange}>
										<option> -- Select Car Model -- </option>
										<option>Camry</option>
										<option>Corolla</option>
										<option>Prado</option>
										<option>Land Cruiser</option>
										<option>FJ Cruiser</option>
									</select>
								</div> */}

                <div class="form-group">
                  <label for="Plate-Number">Plate Number</label>
                  <input
                    type="text"
                    class="form-control"
                    id="Plate-Number"
                    name="plateNumber"
                    value={CarTowing.plateNumber}
                    onChange={handleChange}
                    placeholder="Plate Number"
                  />
                </div>

                <div class="form-group">
                  <label for="g-mb-phone-number">Phone Number</label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="mobileNumberCountryCode"
                        value={CarTowing.mobileNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option>{t('Country Code')}</option>
                        <option>+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        name="mobileNumber"
                        value={CarTowing.mobileNumber}
                        onChange={handleChange}
                        type="tel"
                        className="form-control"
                        id="g-mb-phone-number"
                        placeholder="Phone Number"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="g-mb-whatsApp-number">
                    {t('WhatsApp Number')} <small>(Optional)</small>
                  </label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="whatsAppNumberCountryCode"
                        value={CarTowing.whatsAppNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option>{t('Country Code')}</option>
                        <option>+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        name="whatsAppNumber"
                        value={CarTowing.whatsAppNumber}
                        onChange={handleChange}
                        type="tel"
                        className="form-control"
                        id="g-mb-whatsApp-number"
                        placeholder="WhatsApp Number"
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="g-mb-location-map">
                    Select Location on Map
                  </label>
                  <div className="input-group">
                    <input
                      name="location"
                      value={CarTowing.location || ''}
                      type="text"
                      className="form-control"
                      id="g-mb-location-map"
                      readOnly
                      placeholder="Select Location on Map"
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleOpenMap}
                      >
                        <img
                          src="assets/images/icons/map-marker.svg"
                          alt="Map"
                          style={{ height: '20px', width: '20px' }}
                        />
                      </button>
                    </div>
                  </div>
                  <small className="form-text text-muted">
                    Click to open the map and select your business location
                  </small>
                </div>
                <MapModal
                  open={mapModalOpen}
                  handleClose={handleCloseMap}
                  onLocationSelect={handleLocationSelect}
                  currentLocation={{
                    lat: CarTowing.gps?.lat,
                    long: CarTowing.gps?.long,
                    address: CarTowing?.location,
                  }}
                />

                <div class="form-group">
                  <label>Upload your image</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={
                            LogoImage ? LogoImage : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="Image"
                        >
                          Upload your image
                        </label>
                        <input
                          type="file"
                          id="Image"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class="form-group">
							<div class="row align-items-center">
								<div class="col-auto">
									<div class="circle"><img class="profile-pic img-fluid" src="assets/images/camera.jpg" alt=""/></div>
								</div>
								<div class="col-auto">
									<div class="p-image">
										<a class="btn btn-outline-secondary upload-button btn-sm" href="javascript:void(0);" role="button">Upload your image</a>
										<input class="file-upload" type="file" accept="image/*"/>
									</div>
								</div>
							</div>
						</div> */}

                <div class="form-group">
                  <label> Upload License</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={
                            LicenseImage
                              ? LicenseImage
                              : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="License"
                        >
                          Upload License
                        </label>
                        <input
                          type="file"
                          id="License"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class="form-group">
							<div class="row align-items-center">
								<div class="col-auto">
									<div class="circle"><img class="profile-pic img-fluid" src="assets/images/camera.jpg" alt=""/></div>
								</div>
								<div class="col-auto">
									<div class="p-image">
										<a class="btn btn-outline-secondary upload-button btn-sm" href="javascript:void(0);" role="button">Upload License</a>
										<input class="file-upload" type="file" accept="image/*"/>
									</div>
								</div>
							</div>
						</div> */}

                <div class="form-group">
                  <label> Upload Car Image</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={CarImage ? CarImage : 'assets/images/camera.jpg'}
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="CarImage"
                        >
                          Upload Car Image
                        </label>
                        <input
                          type="file"
                          id="CarImage"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div class="form-group">
							<div class="row align-items-center">
								<div class="col-auto">
									<div class="circle"><img class="profile-pic img-fluid" src="assets/images/camera.jpg" alt=""/></div>
								</div>
								<div class="col-auto">
									<div class="p-image">
										<a class="btn btn-outline-secondary upload-button btn-sm" href="javascript:void(0);" role="button">Upload Car Image</a>
										<input class="file-upload" type="file" accept="image/*"/>
									</div>
								</div>
							</div>
						</div>
						 */}
                {/* Visibility is now a one-click sidebar toggle — modal removed. */}

                <div class="row">
                  <div class="col-6">
                    <button
                      type="reset"
                      onClick={ResetHendler}
                      class="btn btn-secondary btn-block"
                      // href='#'
                      // role='button'
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-taxi-business-packages'
                      class="btn btn-warning btn-block"
                      // href='/sp-taxi-business-packages'
                      // role='button'
                      onSubmit={datasubmit}
                    >
                      {TowingAllList?.length ? 'Update' : 'Save'}
                    </button>
                  </div>
                </div>

                {/* <div class="row">
							<div class="col-6"><a class="btn btn-secondary btn-block" href="#" role="button">{t('Reset')}</a></div>
							<div class="col-6"><a class="btn btn-warning btn-block" href="sp-taxi-manage-business-packages.html" role="button">{t('Next')}</a></div>
						</div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarTawing;
